import { getColumns } from './getColumns'
import { useGetTable } from './useGetTable'
import { useTileFilters } from '../../../hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { TableContent } from './TableContent'
import { tableToFormSchema } from './utils'

export function DataTableComponent({ id }: { id: string }) {
  const { tileFilterSelections } = useTileFilters()

  const { data, refetch, isRefetching } = useGetTable(id, tileFilterSelections)

  type TableDataType = (typeof data)['dataSchema']['data'][number]
  const columns = getColumns<TableDataType>(data.uiSchema)
  const { canCreate, canEdit } = data.uiSchema.tableConfig.permissions || { canCreate: false, canEdit: false }
  const tableActions = data.uiSchema.actions?.table
  const bulkActions = data.uiSchema.actions?.bulk
  const createSubmitHandlerId = data.uiSchema.actions?.table?.find((action) => action.id === 'create')?.handlerId

  return (
    <TableContent
      data={data.dataSchema.data}
      groups={data.dataSchema.groups}
      groupConfig={data.uiSchema.groupConfig}
      columns={columns}
      tableConfig={data.uiSchema.tableConfig}
      formSchema={canCreate || canEdit ? tableToFormSchema(data.uiSchema) : undefined}
      tileFilters={<TileFilter schema={data.filters} />}
      createSubmitHandlerId={createSubmitHandlerId}
      reloadHandler={refetch}
      actions={tableActions}
      bulkActions={bulkActions}
      isRefetching={isRefetching}
    />
  )
}
